import * as Locations from '@/features/application/locations'
import { KeyObjectStore, type KeyObject } from '@/features/shared/tools'
import type { NavigateToLocation } from '@/router/navigateTo'

export type LocationEndPoints = {
  endPointEntite: string
  endPointLov: string
}

export type GetLocationEndPointsEntry = {
  location: KeyObject<NavigateToLocation>
  endPoints: LocationEndPoints
}

export const EndPointsFormationDemandeCapp: GetLocationEndPointsEntry = {
  location: Locations.LocationToFormationDemandeCAPP,
  endPoints: { endPointEntite: '/formations/demandes/capp', endPointLov: '/formations/demandes/capp/lov' },
} as const
export const EndPointsFormationDemandeAf: GetLocationEndPointsEntry = {
  location: Locations.LocationToFormationDemandeAF,
  endPoints: { endPointEntite: '/formations/demandes/af', endPointLov: '/formations/demandes/af/lov' },
} as const
export const EndPointsFormationDemandeCpro: GetLocationEndPointsEntry = {
  location: Locations.LocationToFormationDemandeCPRO,
  endPoints: { endPointEntite: '/formations/demandes/cpro', endPointLov: '/formations/demandes/cpro/lov' },
} as const
export const EndPointsFormationDemandeProa: GetLocationEndPointsEntry = {
  location: Locations.LocationToFormationDemandePROA,
  endPoints: { endPointEntite: '/formations/demandes/proa', endPointLov: '/formations/demandes/proa/lov' },
} as const
export const EndPointsFormationDemandeCxpi: GetLocationEndPointsEntry = {
  location: Locations.LocationToFormationDemandeCXPI,
  endPoints: { endPointEntite: '/formations/demandes/cxpi', endPointLov: '/formations/demandes/cxpi/lov' },
} as const
export const EndPointsFormationDemandeCar: GetLocationEndPointsEntry = {
  location: Locations.LocationToFormationDemandeCAR,
  endPoints: {
    endPointEntite: '/formations/demandes/car',
    endPointLov: '/formations/demandes/car/lov',
  },
} as const
export const EndPointsDrfDemandeCxpi: GetLocationEndPointsEntry = {
  location: Locations.LocationToDrfDemandeCXPI,
  endPoints: { endPointEntite: '/reservationfonds/demandes/cxpi', endPointLov: '/reservationfonds/demandes/cxpi/lov' },
} as const
export const EndPointsFormationDemandeFPE_AF: GetLocationEndPointsEntry = {
  ...EndPointsFormationDemandeAf, // Même endpoint que pour AF
  location: Locations.LocationToFormationDemandeFPE_AF,
} as const
export const EndPointsDrfDossierCxpi: GetLocationEndPointsEntry = {
  location: Locations.LocationToDrfDossierCXPI,
  endPoints: { endPointEntite: '/reservationsfonds', endPointLov: '/reservationfonds/demandes/cxpi/lov' },
} as const
export const EndPointDrDemande: GetLocationEndPointsEntry = {
  location: Locations.LocationToDrDemande,
  endPoints: { endPointEntite: '/remboursements/demandes/dr', endPointLov: '/remboursements/demandes/dr/lov' },
} as const
export const EndPointDrDossier: GetLocationEndPointsEntry = {
  location: Locations.LocationToDrDossier,
  endPoints: { endPointEntite: '/remboursements', endPointLov: '/remboursements/demandes/dr/lov' },
} as const
export const EndPointProformaDemande: GetLocationEndPointsEntry = {
  location: Locations.LocationToProformaDemande,
  endPoints: {
    endPointEntite: '/remboursements/demandes/proforma',
    endPointLov: '/remboursements/demandes/proforma/lov',
  },
}
export const EndPointsTtDemandeOUTILFPE: GetLocationEndPointsEntry = {
  location: Locations.LocationToDemandeOutilFPE,
  endPoints: {
    endPointEntite: '/specifiquestt/demandes/outilfpe',
    endPointLov: '/specifiquestt/demandes/outilfpe/lov',
  },
} as const

const storeEndPoints = new KeyObjectStore<NavigateToLocation, LocationEndPoints>()
storeEndPoints.register(EndPointsFormationDemandeCapp.location, EndPointsFormationDemandeCapp.endPoints)
storeEndPoints.register(EndPointsFormationDemandeAf.location, EndPointsFormationDemandeAf.endPoints)
storeEndPoints.register(EndPointsFormationDemandeCpro.location, EndPointsFormationDemandeCpro.endPoints)
storeEndPoints.register(EndPointsFormationDemandeProa.location, EndPointsFormationDemandeProa.endPoints)
storeEndPoints.register(EndPointsFormationDemandeCxpi.location, EndPointsFormationDemandeCxpi.endPoints)
storeEndPoints.register(EndPointsFormationDemandeCar.location, EndPointsFormationDemandeCar.endPoints)
storeEndPoints.register(EndPointsDrfDemandeCxpi.location, EndPointsDrfDemandeCxpi.endPoints)
storeEndPoints.register(EndPointsDrfDossierCxpi.location, EndPointsDrfDossierCxpi.endPoints)
storeEndPoints.register(EndPointDrDemande.location, EndPointDrDemande.endPoints)
storeEndPoints.register(EndPointDrDossier.location, EndPointDrDossier.endPoints)
storeEndPoints.register(EndPointProformaDemande.location, EndPointProformaDemande.endPoints)
storeEndPoints.register(EndPointsFormationDemandeFPE_AF.location, EndPointsFormationDemandeFPE_AF.endPoints)
storeEndPoints.register(EndPointsTtDemandeOUTILFPE.location, EndPointsTtDemandeOUTILFPE.endPoints)

export function locationToEndPointsDemande(query: KeyObject<NavigateToLocation>) {
  const result = storeEndPoints.tryGetData(query)
  if (!result) throw new Error('Aucun endpoint sur cette localisation')
  return result
}
